import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { AlertSelector } from '../../../selectors/alert';
import { deepEqual } from '../../../service/utils';
import { useAddTimeoutID } from '../../../actions/alert';
import { useHandler } from '../../../components/hooks/useAlert/useHandler';
import {
    checkAlertEnabled,
    checkDurationOfFlight,
    checkLanding,
    checkTakeOff,
    checkTocPoint,
    checkTodPoint,
} from '../../../service/alert/tools';

export const useAlert = (type, onDismiss) => {
    const { legId, allowed, interval, popupType, nextAlert } = useSelector(AlertSelector[type], deepEqual);

    const isAlertEnabled = checkAlertEnabled({ allowed });
    const isTakeOff = checkTakeOff();
    const isTocPointAto = checkTocPoint();
    const isTodPointAto = checkTodPoint();
    const isLanding = checkLanding();
    const isFightDurationLongerTimout = checkDurationOfFlight();
    const handler = useHandler(legId, onDismiss);
    const addTimeoutID = useAddTimeoutID();
    const acceptedAlert = isAlertEnabled && isTakeOff && (isTocPointAto || isFightDurationLongerTimout) && !isTodPointAto && !isLanding;

    const handleTimeoutOver = useCallback(() => {
        handler(popupType, legId);
    }, [type, popupType, handler, legId]);

    return useCallback(() => {
        if (acceptedAlert) {
            const nextAlertDate = moment.utc(nextAlert).add(interval, 'milliseconds').toISOString();
            const restTime = moment.utc(nextAlertDate).diff(moment.utc(), 'milliseconds');
            const timeoutId = setTimeout(handleTimeoutOver, restTime);
            addTimeoutID({ legId, type, timeoutId, date: nextAlertDate });
        }
    }, [acceptedAlert, legId, type, interval, nextAlert, handleTimeoutOver]);
};
